import React from 'react';
import { CrossFieldContent, CrossFieldDoubleRow, CrossFieldSingleRow, FieldCaption, FieldTooltip, Root, } from '../styles';
import TextInput from './TextInput';
var CrossTextInput = function (props) {
    var id = props.id, caption = props.caption, captions = props.captions, values = props.values, tooltip = props.tooltip, onChange = props.onChange;
    var topCaption = captions[0], leftCaption = captions[1], rightCaption = captions[2], bottomCaption = captions[3];
    var top = values[0], left = values[1], right = values[2], bottom = values[3];
    var handleChange = function (key) {
        return function (value) {
            var _a;
            if (onChange) {
                if (!Number.isNaN(Number(value))) {
                    var obj = (_a = { top: top, left: left, right: right, bottom: bottom }, _a[key] = value, _a);
                    onChange([obj.top, obj.left, obj.right, obj.bottom]);
                }
            }
        };
    };
    return (React.createElement(Root, { size: "fill" },
        React.createElement(FieldCaption, { style: { margin: '0 5px' } }, caption),
        React.createElement(CrossFieldContent, null,
            React.createElement(CrossFieldSingleRow, null,
                React.createElement(TextInput, { size: "xSmall", value: top, contentType: "number", caption: topCaption, id: "".concat(id, "-top"), inside: true, suffix: "px", onChange: handleChange('top') })),
            React.createElement(CrossFieldDoubleRow, null,
                React.createElement(TextInput, { size: "xSmall", value: left, contentType: "number", caption: leftCaption, id: "".concat(id, "-left"), inside: true, suffix: "px", onChange: handleChange('left') }),
                React.createElement(TextInput, { size: "xSmall", value: right, contentType: "number", caption: rightCaption, id: "".concat(id, "-right"), inside: true, suffix: "px", onChange: handleChange('right') })),
            React.createElement(CrossFieldSingleRow, null,
                React.createElement(TextInput, { size: "xSmall", value: bottom, contentType: "number", caption: bottomCaption, id: "".concat(id, "-bottom"), inside: true, suffix: "px", onChange: handleChange('bottom') }))),
        React.createElement(FieldTooltip, { style: { margin: '0 5px' } }, tooltip)));
};
export default CrossTextInput;
//# sourceMappingURL=CrossTextInput.js.map